import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { ToggleableModulesService } from '../../features/config/toggleable-modules/toggleable-modules.service'
import { ToggleableModulesName } from '../../features/config/toggleable-modules/ToggleableModules'
import { first, map, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ActiveModuleGuardService {
  private toggleableModulesService = inject(ToggleableModulesService)
  private router = inject(Router)

  static TAG = 'ActiveModuleGuardService'

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const dependencies: ToggleableModulesName[] = route.data.dependencies

    // If no dependencies are defined, allow access
    if (!dependencies || dependencies.length === 0) {
      console.log(ActiveModuleGuardService.TAG, 'canActivate - no dependencies, allowing access')
      return true
    }

    return this.toggleableModulesService.isAllActive(dependencies).pipe(
      first(),
      tap((e) => console.log(ActiveModuleGuardService.TAG, 'canActivate', dependencies)),
      map((result) => {
        if (!result) return this.router.parseUrl('/menu/app/tabs/welcome')
        return true
      }),
    )
  }
}

export const ActiveModuleGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(ActiveModuleGuardService).canActivate(next, state)
}
